import apiClient, { USE_MOCK } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { mockQuizData } from './mockQuizData';

// 根據 USE_MOCK 設定決定使用真實 API 或 Mock 資料
// 模擬網路延遲
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

/*
篇章列表
34 interact001 System, Member, Viewer
 */
export const get34QuizChapterList = async () => {
  if (USE_MOCK) {
  // if (1) {
    await delay(300);
    return {
      data: mockQuizData.i34ChapterList,
    };
  }

  return apiClient.get(ENDPOINTS.QUIZ.i34_CHAPTER_LIST);
};

/*
篇章題目列表
35 interact002 Member
 */
export const post35QuizList = async (
  chapter_id, 
  question_random = false, 
  option_random = false
  ) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockQuizData.i35QuestionList,
    };
  }

  return apiClient.post(ENDPOINTS.QUIZ.i35_LIST, { 
    chapter_id: Number(chapter_id), 
    question_random, 
    option_random });
};

/*
題目答案確認
36 interact003 Member
 */
export const post36QuizAnswer = async (question_id, option_id) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockQuizData.i36QuestionAnswer(
        Number(question_id),
        Number(option_id),
      )
    };
  }

  return apiClient.post(ENDPOINTS.QUIZ.i36_ANSWER, { question_id, option_id });
};

/*
題目答案確認
75 interact006 Member, Viewer
 */
export const post75QuizScore = async (chapter_id) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockQuizData.i75QuestionScore(chapter_id),
    };
  }
  return apiClient.post(ENDPOINTS.QUIZ.i75_SCORE, { chapter_id });
}
//---------------------------------------------------------------------------
export default {
  get34QuizChapterList,
  post35QuizList,
  post36QuizAnswer,
  post75QuizScore,
};
